import { atomWithStorage, createJSONStorage } from 'jotai/vanilla/utils';

import { useAtom } from '@/utils/jotai-svelte';

const storage = createJSONStorage<boolean>(() => localStorage);
export const ShowPDFPreview$ = atomWithStorage<boolean>('showPDFPreview', false, storage);

export const useShowPDFPreview = () => useAtom(ShowPDFPreview$);
